import React from 'react';

import styled from '@emotion/styled';
import { Container, PrimaryButton } from '@styles';

const StyledPageHeader = styled.section`
  width: 100%;
  position: relative;
  overflow: hidden;
  background: var(--deepBlue);
  padding: 1.5rem;

  @media (max-width: 300px) {
    padding: 1rem;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  align-items: center;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
    grid-template-rows: 2fr;
  }
`;

const IconWrapper = styled.div`
  margin: auto;
  img {
    width: 60px;
    @media (max-width: 200px) {
      display: none;
    }
  }
`;

const StyledText = styled.div`
  color: var(--text);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  align-items: center;

  h2 {
    font-weight: 3.3rem;
    font-weight: 300;
    line-height: 1.2;
    margin: 0;
  }

  span {
    opacity: 0.75;
  }

  @media (max-width: 460px) {
    h2 {
      font-size: 2rem;
    }
    span {
      font-size: 15px;
    }
  }
`;

const PageHeader = ({
  title,
  subtitle,
  imageUrl,
  imageAlt,
  primaryButton,
  link,
}) => (
  <StyledPageHeader>
    <Container normal>
      <GridContainer>
        <StyledText>
          <IconWrapper>
            <img src={imageUrl} alt={imageAlt} />
          </IconWrapper>
          <div>
            <h2> {title}</h2>
            <span>{subtitle}</span>
          </div>
        </StyledText>
        {primaryButton && (
          <PrimaryButton to={link}>{primaryButton}</PrimaryButton>
        )}
      </GridContainer>
    </Container>
  </StyledPageHeader>
);

export default PageHeader;
